
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/avtalevilkar",
      function () {
        return require("private-next-pages/avtalevilkar.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/avtalevilkar"])
      });
    }
  